module.exports = __webpack_public_path__ + "media/entities/1804-42c45d43.png";